export const ocppLogs = {
  title: 'OCPP 日誌',
  pageTitle: 'OCPP 日誌查詢',
  subtitle: '搜尋並分析所有充電樁的 OCPP 通訊協定日誌',
  filters: {
    title: '搜尋篩選條件',
    ocppServer: 'OCPP 伺服器',
    ocppServerPlaceholder: '搜尋 OCPP 伺服器...',
    ocppServerRequired: 'OCPP 伺服器 *',
    charger: '充電樁',
    chargerPlaceholder: '搜尋充電樁...',
    chargerHelper: '留空以搜尋所有充電樁',
    dateRange: '日期範圍',
    startDateTime: '開始日期時間',
    endDateTime: '結束日期時間',
    actionType: '動作類型',
    direction: '方向',
    logLevel: '日誌等級',
  },
  dateRanges: {
    last1Hour: '最近 1 小時',
    last24Hours: '最近 24 小時',
    today: '今天',
    customRange: '自訂範圍',
  },
  actions: {
    allActions: '所有動作',
    startTransaction: '開始交易',
    stopTransaction: '停止交易',
    meterValues: '電量數值',
    statusNotification: '狀態通知',
    authorize: '授權',
    heartbeat: '心跳',
    bootNotification: '開機通知',
    remoteStartTransaction: '遠端開始交易',
    remoteStopTransaction: '遠端停止交易',
  },
  directions: {
    allDirections: '所有方向',
    incoming: '接收 (充電樁 → OCPP 伺服器)',
    outgoing: '發送 (OCPP 伺服器 → 充電樁)',
  },
  levels: {
    allLevels: '所有等級',
    error: '錯誤',
    warning: '警告',
    info: '資訊',
    debug: '除錯',
  },
  buttons: {
    searchLogs: '搜尋日誌',
    refresh: '使用目前篩選條件重新整理',
  },
  messages: {
    serverSelected: '已選擇伺服器。您現在可以搜尋 OCPP 日誌。',
    selectServer: '請選擇 OCPP 伺服器以開始搜尋日誌',
    noLogsFound: '找不到日誌。請嘗試調整搜尋篩選條件或日期範圍。',
    loadingServers: '載入伺服器中...',
    loadingChargers: '載入充電樁中...',
    noServersFound: '找不到 OCPP 伺服器',
    noChargersFound: '此伺服器找不到充電樁',
    selectServerFirst: '請先選擇伺服器',
    loading: '載入中...',
  },
  results: {
    title: '搜尋結果',
    showing: '顯示 %{total} 個日誌中的 %{count} 個',
  },
  logEntry: {
    timestamp: '時間戳記',
    ocppAction: 'OCPP 動作',
    direction: '方向',
    fullLogData: '完整日誌資料',
  },
  badges: {
    incoming: '接收 (充電樁 → OCPP 伺服器)',
    outgoing: '發送 (OCPP 伺服器 → 充電樁)',
  },
};
